// export const BASE_URL = "http://localhost:5001/vapi"
// export const VIDEO_API_BASE = "http://localhost:5001/vapi"
// export const FUI = "http://localhost:5173"


export const BASE_URL = "https://process.jobexcello.com/vapi"
export const VIDEO_API_BASE = "https://process.jobexcello.com/vapi"
export const FUI = "https://jobexcello.com"

const defaultconfig = {
  DISABLE_CONVERSATIONS: 'false',
  DANGEROUSLY_DISABLE_HOST_CHECK: 'true',
};

export default defaultconfig;